/**
 * Mirrors the backend's shared/api types. Keep these in sync when the
 * server-side records change.
 */

export interface ApiError {
  code: string;
  message: string;
  status: number;
  path?: string | null;
  timestamp?: string | null;
  fieldErrors?: FieldError[];
}

export interface FieldError {
  field: string;
  message: string;
}

export interface PageResponse<T> {
  items: T[];
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

/**
 * Thrown by {@link apiRequest} on any non-2xx response. Carry the full
 * structured {@link ApiError} so callers can render fieldErrors on forms or
 * branch on the error code.
 */
export class ApiException extends Error {
  readonly error: ApiError;

  constructor(error: ApiError) {
    super(error.message);
    this.error = error;
    this.name = 'ApiException';
  }
}
